module.exports = __webpack_public_path__ + "static/media/Airplane_silhouette_white.b4b2325d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Airplane_silhouette_white.svg
// module id = 168
// module chunks = 0